// extracted by mini-css-extract-plugin
var _1 = "FileAttachTag-moduleFileAttachTag__I2DI9 Tag-moduleTag__FLr9H";
var _2 = "FileAttachTag-modulefileSize__ccyzb";
export { _1 as "FileAttachTag", _2 as "fileSize" }
